module.exports = __webpack_public_path__ + "img/台灣之星.30619c81.png";